import { memo, type FunctionComponent } from 'react';
import map from 'lodash/map';
import size from 'lodash/size';
// Material UI imports
import Box from '@mui/material/Box';
// Skillmore UI Components
import FetchFailedAlert from '@empathco/ui-components/src/elements/FetchFailedAlert';
import InlineAlert from '@empathco/ui-components/src/elements/InlineAlert';
import LoadingPlaceholder from '@empathco/ui-components/src/elements/LoadingPlaceholder';
// local imports
import { Skill } from '../models/skill';
import SelectableSkillCard from '../v3/SelectableSkillCard';
// SCSS imports
import { root } from './SelectableSkills.module.scss';

type SelectableSkillsProps = {
  readonly skills?: Skill[] | null;
  readonly pending?: boolean | null;
  readonly failed?: boolean | null;
  readonly onClick?: (skill: Skill) => void;
  readonly disabled?: boolean | null;
  readonly notFoundMessage?: string | null;
}

const SelectableSkills: FunctionComponent<SelectableSkillsProps> = ({
  skills,
  pending = false,
  failed = false,
  disabled = false,
  onClick,
  notFoundMessage
}) =>
  ((failed || pending || size(skills) < 1) && (
    <Box pb={4}>
      {(failed && <FetchFailedAlert flat/>) ||
      (pending && <LoadingPlaceholder flat/>) || (
        <InlineAlert severity="info" message={notFoundMessage || 'skills.no_skills_found'} flat/>
      )}
    </Box>
  )) || (
    <Box
        px={3}
        py={4}
        display="flex"
        flexWrap="wrap"
        alignContent="flex-start"
        className={root}
    >
      {map(skills, (skill) => (
        <Box
            key={skill.id}
            pr={3.5}
            pb={4}
        >
          <SelectableSkillCard
              skill={skill}
              disabled={disabled}
              onClick={onClick}
          />
        </Box>
      ))}
    </Box>
  );

export default memo(SelectableSkills);
